'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bridge = require('@beastshop/bridge');

var _bridge2 = _interopRequireDefault(_bridge);

var _browser = require('@beastshop/browser');

var _wrapTrack = require('./wrap-track');

var _wrapTrack2 = _interopRequireDefault(_wrapTrack);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var name = _ref.name,
      attrs = _ref.attrs,
      _ref$wait = _ref.wait,
      wait = _ref$wait === undefined ? false : _ref$wait;

  if ((0, _browser.app)()) {
    _bridge2.default.track({
      name: name,
      attrs: attrs
    });
    return Promise.resolve();
  } else {
    try {
      var _resolve = void 0;
      var promise = new Promise(function (resolve) {
        _resolve = resolve;
      });
      (0, _wrapTrack2.default)({
        name: name,
        attrs: attrs
      });
      if (wait) {
        setTimeout(_resolve, 200);
      } else {
        _resolve();
      }
      return promise;
    } catch (e) {}
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@beastshop/tracker-m/lib/index.js
// module id = 149
// module chunks = 0